export default __webpack_public_path__ + "static/media/mailPink.d6d9d656.png";